export default __webpack_public_path__ + "3ca010091104955549637f036ccd5946.svg";